import React from 'react';
import {
    Button
} from '@rebrandly/styleguide'

const TwitterShareButton = ({ url, buttonProps = {} }) => {
    if (!url) {
        return null;
    }

    const shareUrl = new URL('https://twitter.com/share');
    shareUrl.searchParams.set('url', url);

    const openShareWindow = () => {
        window.open(
            shareUrl.toString(),
            'twitter-share',
            'width=550,height=400'
        );
    };

    return (
        <Button
            onClick={openShareWindow}
            {...buttonProps}
        >
            {buttonProps.children}
        </Button>
    );
};

export default TwitterShareButton;